module.exports = __webpack_public_path__ + "static/media/6.3b862775.png";